import { useContext } from "react";
import { TnCContext } from "../contexts/TnCContext";


export const useTnC = (tncChecked: boolean | undefined) => {
  const context = useContext(TnCContext);

  if (context === undefined) {
    throw new Error("useTnC must be used within a TnCProvider");
  }

  return context;
};
